import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ReviewFilters } from '@/types';

interface UIState {
  // Sidebar state
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;

  // Selected location
  selectedLocationId: string | null;
  setSelectedLocationId: (locationId: string | null) => void;

  // Review filters
  reviewFilters: ReviewFilters;
  setReviewFilters: (filters: ReviewFilters) => void;
  resetReviewFilters: () => void;

  // Onboarding progress
  onboardingStep: number;
  setOnboardingStep: (step: number) => void;
  completeOnboarding: () => void;
}

const defaultFilters: ReviewFilters = {
  locationId: undefined,
  hasReply: undefined,
  starRating: undefined,
  status: undefined,
  searchQuery: undefined,
};

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      // Sidebar
      sidebarOpen: true,
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

      // Location selection
      selectedLocationId: null,
      setSelectedLocationId: (locationId) => set({ selectedLocationId: locationId }),

      // Review filters
      reviewFilters: defaultFilters,
      setReviewFilters: (filters) =>
        set((state) => ({
          reviewFilters: { ...state.reviewFilters, ...filters },
        })),
      resetReviewFilters: () => set({ reviewFilters: defaultFilters }),

      // Onboarding
      onboardingStep: 0,
      setOnboardingStep: (step) => set({ onboardingStep: step }),
      completeOnboarding: () => set({ onboardingStep: -1 }),
    }),
    {
      name: 'tapreply-ui-storage',
      partialize: (state) => ({
        sidebarOpen: state.sidebarOpen,
        selectedLocationId: state.selectedLocationId,
        onboardingStep: state.onboardingStep,
      }),
    }
  )
);
